import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useUserStore } from '@/stores/user'
import { messageApi, type MessageCategoryItem } from '@/api/message'

const sumUnreadCount = (data: unknown): number => {
  if (!Array.isArray(data)) return 0
  return data.reduce((total, item) => {
    if (!item || typeof item !== 'object') return total
    const count = Number((item as MessageCategoryItem).unreadCount)
    return total + (Number.isFinite(count) ? count : 0)
  }, 0)
}

export const useMessageStore = defineStore('message', () => {
  /** 各消息分类 unreadCount 累积求和 */
  const unreadCount = ref(0)

  let inflight: Promise<boolean> | null = null

  const hasValidRefreshToken = () => {
    const userStore = useUserStore()
    const refreshToken = userStore.userInfo?.refreshToken || localStorage.getItem('refreshToken')
    return userStore.isLoggedIn && !!refreshToken
  }

  const reset = () => {
    inflight = null
    unreadCount.value = 0
  }

  /** 已登录且刷新令牌有效时拉取消息分类并累计未读数；未登录不发请求 */
  const fetchCategories = async (): Promise<boolean> => {
    if (!hasValidRefreshToken()) {
      return false
    }
    if (inflight) {
      return inflight
    }

    inflight = (async () => {
      try {
        const res = await messageApi.queryCategories()
        if (!hasValidRefreshToken()) {
          return false
        }
        if (res?.code !== 0) {
          console.error('[messageStore] 查询消息分类失败:', res?.message)
          return false
        }
        unreadCount.value = sumUnreadCount(res.data)
        return true
      } catch (error) {
        console.error('[messageStore] 查询消息分类失败:', error)
        return false
      } finally {
        inflight = null
      }
    })()

    return inflight
  }

  return {
    unreadCount,
    fetchCategories,
    reset,
  }
})
